import { render, staticRenderFns } from "./BbeeCampanasComercialesOC.vue?vue&type=template&id=6275e6a1"
import script from "./BbeeCampanasComercialesOC.vue?vue&type=script&lang=js"
export * from "./BbeeCampanasComercialesOC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports